export default function translate(i18n, propriete) {
  if (propriete === 'siren') {
    return i18n.t('creerClient.labelChamp.siren');
  }
  if (propriete === 'referenceHavas') {
    return i18n.t('creerClient.labelChamp.referenceHavas');
  }
  return propriete;
}
